export default {
	setOurTeam(state, our_team) {
		state.our_team = our_team
	},
}
